import { TextField } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useEffect, useState } from "react";
import Autocomplete from "@mui/material/Autocomplete";
import { city } from "../Data/maharashtraCity";

export const MultipleElasticSearch = (props) => {
  const { 
    title, 
    itemList, 
    setSearchData, 
    searchData, 
    keyValue,
    // New props for advanced search
    advancedSearchFilters,
    handleAdvancedSearchChange
  } = props;

  const handleChange = (event, newValue) => {
    // console.log("🔽 MultipleElasticSearch change:", keyValue, newValue);
    
    // If we have advanced search functions, use them (no API trigger)
    if (handleAdvancedSearchChange && advancedSearchFilters) {
      handleAdvancedSearchChange(keyValue, newValue);
      return;
    }
    
    // Fallback to original behavior
    setSearchData({
      ...searchData,
      [`${keyValue}`]: newValue,
    });
  };

  // Get the current value from the appropriate source
  const getCurrentValue = () => {
    if (advancedSearchFilters && advancedSearchFilters[keyValue] !== undefined) {
      const value = advancedSearchFilters[keyValue];
      // If it's a string, split by comma to get array for Autocomplete
      if (typeof value === 'string' && value.trim() !== '') {
        return value.split(',').map(item => item.trim()).filter(item => item !== '');
      }
      // If it's already an array, return as is
      if (Array.isArray(value)) {
        return value;
      }
      // If it's an empty string, return empty array
      if (value === '') {
        return [];
      }
    }
    return searchData[`${keyValue}`] || [];
  };

  // Force re-render when advanced search filters are cleared
  useEffect(() => {
    // This will trigger a re-render and getCurrentValue will return the updated value
  }, [advancedSearchFilters]);

  return (
    <Autocomplete
      multiple
      id="tags-outlined"
      options={itemList.sort()}
      getOptionLabel={(option) => option}
      defaultValue={[]}
      value={getCurrentValue()}
      onChange={handleChange}
      sx={{
        width: "48%",
        margin: "0.5rem 0rem",
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          label={title}
          placeholder=""
        />
      )}
    />
  );
};
